import { FunctionComponent, memo, useState } from 'react';
import { FormControl, FormControlLabel, Switch } from '@material-ui/core';
import { useUnlikedGatewayMutation } from '../../../../store/api-slice';
import { MedisanteDevice } from '../../../../pages/Device/types';
import { useConfig } from '../../../../eliot-components/src/ConfigProvider/hooks';

interface Props {
  devices: MedisanteDevice[];
  onUnlinkedChange(unlinked: boolean, err: any): void;
}

const UnlinkedGatewaySwitch: FunctionComponent<Props> = memo(
  ({ devices, onUnlinkedChange }) => {
    const [unlinkedDevice, { isLoading }] = useUnlikedGatewayMutation();
    const [unlinked] = useState(
      devices.length > 0 ? devices[0].allowUnlinkedGateway : false
    );
    const config = useConfig();
    return (
      <FormControl>
        <FormControlLabel
          control={
            <Switch
              color="primary"
              checked={unlinked}
              disabled={isLoading}
              onChange={(e) => {
                unlinkedDevice({
                  apiBaseURL: config.apiBaseURL,
                  devices,
                  allow: e.target.checked,
                })
                  .then(() => {
                    onUnlinkedChange(e.target.checked, null);
                  })
                  .catch((err) => {
                    onUnlinkedChange(false, err.message);
                  });
              }}
            />
          }
          label="Unlinked"
        />
      </FormControl>
    );
  }
);

export default UnlinkedGatewaySwitch;
